import * as React from "react";
import { CustomIconProps, getPixels } from "../index";

export const CustomGithubIcon = React.forwardRef<
  SVGSVGElement,
  CustomIconProps
>(({ size: rawSize = "md", ...props }, ref) => {
  const size = getPixels(rawSize);
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      {...props}
    >
      <g>
        <path
          d="M12.009.933C5.921.933 1 5.891 1 12.024c0 4.903 3.153 9.053 7.528 10.522.547.11.747-.239.747-.533 0-.257-.018-1.138-.018-2.056-3.063.661-3.7-1.322-3.7-1.322-.492-1.286-1.222-1.616-1.222-1.616-1.002-.68.073-.68.073-.68 1.112.074 1.696 1.139 1.696 1.139.984 1.689 2.57 1.212 3.207.918.092-.716.383-1.212.693-1.487-2.442-.258-5.012-1.212-5.012-5.473a4.34 4.34 0 0 1 1.13-2.974c-.11-.275-.492-1.414.109-2.938 0 0 .93-.294 3.026 1.138a10.609 10.609 0 0 1 2.752-.367c.93 0 1.877.129 2.752.367 2.096-1.432 3.026-1.138 3.026-1.138.602 1.524.219 2.663.109 2.938.711.771 1.13 1.763 1.13 2.974 0 4.261-2.569 5.197-5.03 5.473.401.348.747 1.009.747 2.056 0 1.487-.018 2.681-.018 3.048 0 .294.201.643.747.533A11.082 11.082 0 0 0 23 12.024C23.018 5.891 18.079.933 12.009.933Z"
          fill="currentColor"
          stroke="none"
          strokeWidth="2"
          strokeLinejoin="round"
          strokeLinecap="round"
          strokeMiterlimit="8"
        />
      </g>
    </svg>
  );
});

CustomGithubIcon.displayName = "CustomGithubIcon";
